import React from 'react';
import _ from 'lodash';
import Workbook from 'vendor/react-excel-workbook';

export const getExportData = (taskData) => {
  let exportData = _.map(taskData, (task) => {
    let subApplication = _.get(task, 'subApplication');
    return {
      ...task,
      fedShare: '$' + _.get(task, 'fedShare', '0.00'),
      totalShare: '$' + _.get(task, 'totalShare', 0).toFixed(2),
      infrastructureScore: _.get(task, 'infrastructureScore', 0).toFixed(0),
      natureBasedSolutionsScore: _.get(task, 'natureBasedSolutionsScore', 0).toFixed(0),
      buildingCodesScore: _.get(task, 'buildingCodesScore', 0).toFixed(0),
      bcegsScore: _.get(task, 'bcegsScore', 0).toFixed(0),
      advanceAssistanceScore: _.get(task, 'advanceAssistanceScore', 0).toFixed(0),
      increasedNonFederalCostShareScore: _.get(
        task,
        'increasedNonFederalCostShareScore',
        0
      ).toFixed(0),
      smallImpoverishedCommunityScore: _.get(
        task,
        'smallImpoverishedCommunityScore',
        0
      ).toFixed(0),
      technicalEvaluationCriteriaScore: _.get(
        task,
        'technicalEvaluationCriteriaScore',
        0
      ).toFixed(0),
      primaryActivityType: subApplication.primaryActivityType,
      primarySubActivityType: subApplication.primarySubActivityType,
      secondaryActivityType: subApplication.secondaryActivityType,
      secondarySubActivityType: subApplication.secondarySubActivityType,
      primaryCommunityLifeline: subApplication.primaryCommunityLifeline,
      primarySubCommunityLifeline: subApplication.primarySubCommunityLifeline,
      phasedProject: subApplication.phasedProject,
    };
  });
  return exportData;
};

export const SelectionForPanelsWorkBook = ({exportRef, taskData}) => {
  const exportData = getExportData(taskData);

  return (
    <Workbook filename="SelectionForPanels.xlsx" element={<span ref={exportRef} />}>
      <Workbook.Sheet data={exportData} name="Dashboard Sheet">
        <Workbook.Column label="Subgrant ID" value="subGrantId" />
        <Workbook.Column label="Suborganization" value="subOrganizationName" />
        <Workbook.Column label="Organization" value="organizationName" />
        <Workbook.Column label="Infrastructure score" value="infrastructureScore" />
        <Workbook.Column
          label="Nature-based Solutions score"
          value="natureBasedSolutionsScore"
        />
        <Workbook.Column label="Building Codes score" value="buildingCodesScore" />
        <Workbook.Column label="BCEGS score" value="bcegsScore" />
        <Workbook.Column
          label="Advance Assistance score"
          value="advanceAssistanceScore"
        />
        <Workbook.Column
          label="Increased Non-federal cost share score"
          value="increasedNonFederalCostShareScore"
        />
        <Workbook.Column label="EDRC score" value="smallImpoverishedCommunityScore" />
        <Workbook.Column
          label="Tech evaluation score total"
          value="technicalEvaluationCriteriaScore"
        />
        <Workbook.Column label="Federal share" value="fedShare" />
        <Workbook.Column label="Total project cost" value="totalShare" />
        <Workbook.Column label="Region" value="region" />
        <Workbook.Column label="State" value="organizationState" />
        <Workbook.Column label="Primary activity type" value="primaryActivityType" />
        <Workbook.Column
          label="Primary subactivity type"
          value="primarySubActivityType"
        />
        <Workbook.Column label="Secondary activity" value="secondaryActivityType" />
        <Workbook.Column
          label="Secondary subactivity type"
          value="secondarySubActivityType"
        />
        <Workbook.Column label="Primary lifeline" value="primaryCommunityLifeline" />
        <Workbook.Column
          label="Sub-community lifeline"
          value="primarySubCommunityLifeline"
        />
        <Workbook.Column label="Phased project (Y/N)" value="phasedProject" />
      </Workbook.Sheet>
    </Workbook>
  );
};

export default SelectionForPanelsWorkBook;
